import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";

const CITIES = [
    "Альметьевск", "Азнакаево", "Бавлы", "Бугульма", "Карабаш",
    "Лениногорск", "Малая Бугульма", "Нижняя Мактама", "Казань",
    "Зеленодольск", "Мензелинск",
    "Октябрьский"
];

const CITY_STATES = {
    "Альметьевск": "Татарстан", "Азнакаево": "Татарстан", "Бавлы": "Татарстан",
    "Бугульма": "Татарстан", "Карабаш": "Татарстан", "Лениногорск": "Татарстан",
    "Малая Бугульма": "Татарстан", "Нижняя Мактама": "Татарстан",
    "Казань": "Татарстан", "Зеленодольск": "Татарстан", "Мензелинск": "Татарстан",
    "Октябрьский": "Башкортостан",
};

const CitySelector = () => {
    const [city, setCity] = useState(() => {
        return localStorage.getItem("selected_city") || Cookies.get("start-address-city") || "";
    });
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (city) {
            localStorage.setItem("selected_city", city);
            Cookies.set("start-address-city", city, { expires: 30 });
            const state = CITY_STATES[city] || "";
            if (state) {
                localStorage.setItem("selected_state", state);
                Cookies.set("start-address-state", state, { expires: 30 });
            }
        }
    }, [city]);

    // Auto-detect city by IP on first open
    useEffect(() => {
        if (!city) {
            fetch("https://ipapi.co/json/")
                .then(r => r.json())
                .then(data => {
                    if (data.city) {
                        const matched = CITIES.find(c =>
                            data.city.toLowerCase().includes(c.toLowerCase()) ||
                            c.toLowerCase().includes(data.city.toLowerCase())
                        );
                        if (matched) {
                            setCity(matched);
                        }
                    }
                })
                .catch(() => {});
        }
    }, []);

    const selectCity = (c) => {
        setCity(c);
        setIsOpen(false);
    };

    // Compact view — city selected
    if (city && !isOpen) {
        return (
            <div
                onClick={() => setIsOpen(true)}
                style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "6px 16px",
                    cursor: "pointer",
                    gap: "4px",
                }}
            >
                <span style={{ fontSize: "18px" }}>&#x1F4CD;</span>
                <span style={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#e5e7eb",
                }}>
                    {city}
                </span>
                <span style={{ fontSize: "10px", color: "#6b7280", marginLeft: "2px" }}>&#x25BC;</span>
            </div>
        );
    }

    // Expanded view — city picker
    return (
        <div style={{ padding: "8px 16px 4px" }}>
            {!city && (
                <div style={{
                    fontSize: "13px",
                    color: "#9ca3af",
                    marginBottom: "6px",
                }}>
                    Выберите город
                </div>
            )}
            <div style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "6px",
                maxHeight: "100px",
                overflowY: "auto",
            }}>
                {CITIES.map(c => (
                    <button
                        key={c}
                        onClick={() => selectCity(c)}
                        style={{
                            padding: "5px 10px",
                            borderRadius: "6px",
                            border: city === c ? "2px solid #10b981" : "1px solid #4b5563",
                            background: city === c ? "#064e3b" : "transparent",
                            color: city === c ? "#10b981" : "#d1d5db",
                            fontSize: "12px",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {c}
                    </button>
                ))}
            </div>
            {city && (
                <div
                    onClick={() => setIsOpen(false)}
                    style={{
                        fontSize: "12px",
                        color: "#6b7280",
                        textAlign: "right",
                        marginTop: "4px",
                        cursor: "pointer",
                    }}
                >
                    Закрыть
                </div>
            )}
        </div>
    );
};

export default CitySelector;
